import { render } from "./MonthlyPlan.vue?vue&type=template&id=07835a16"
import script from "./MonthlyPlan.vue?vue&type=script&lang=js"
export * from "./MonthlyPlan.vue?vue&type=script&lang=js"

import "./MonthlyPlan.vue?vue&type=style&index=0&id=07835a16&lang=css"

import exportComponent from "/var/www/new_dev_tis/frontend/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__